import { sumDecimals } from './decimal.utils.js';
export const thirdPartyAccountPrefix = '4';
export const treasureAccountPrefix = '5';
export const bankAccountPrefix = '512';
export const supplierAccountPrefix = '401';
export const clientAccountPrefix = '411';
// A salarié's 411 line is told by its code rather than by its card link: a relinked salarié's
// locked écritures stay on a former 411 that no card points at any more.
export const isClientAccountLine = (line) => line.financialAccount.code.startsWith(clientAccountPrefix);
export const clientAccountLineWhere = {
    financialAccount: { code: { startsWith: clientAccountPrefix } },
};
// PCG class 58 "Virements internes" — the transit account used to split an internal transfer
// into two balanced entries (one per bank journal). Prefix (not exact 580) to match imported
// plans coded 58/585/588, same lesson as the 471 proforma prefix.
export const internalTransferAccountPrefix = '58';
export const cutOffAccountPrefixes = ['408', '418', '486', '487'];
export const sensitiveAccountPrefixes = ['471', '472'];
export const waitingAccountPrefix = '47';
// Amortizable assets: incorporelles (20), corporelles (21), en concession (22); never 23 or 26/27.
export const immobilisationAccountPrefixes = ['20', '21', '22'];
export const amortissementAccountPrefix = '28';
export const dotationAccountPrefix = '68';
export const surplusResultAccountPrefix = '120';
export const deficitResultAccountPrefix = '129';
export const resultAccountPrefix = '12';
// PCG classes 1 to 5 make the bilan and are carried into the next exercice; everything else
// (charges, produits) nets into the résultat.
export function isBalanceSheetAccountCode(code) {
    return /^[1-5]/.test(code);
}
// PCG classes (« 1 ») and sub-classes (« 21 ») only group accounts; recording accounts have at
// least 3 digits. Deeper parents stay postable: imported charts nest auxiliaries under a
// collectif (401, 411) that keeps receiving entries.
const MIN_POSTABLE_ACCOUNT_CODE_LENGTH = 3;
export function isPostableAccountCode(code) {
    return code.trim().length >= MIN_POSTABLE_ACCOUNT_CODE_LENGTH;
}
export const NON_POSTABLE_ACCOUNT_MESSAGE = "Un compte de classe ou de sous-classe (moins de 3 chiffres) regroupe d'autres comptes : il ne peut pas recevoir d'écriture";
// Suggests a supplier `code` from a FEC account label (libellé): the first 4 letters/digits,
// uppercased (e.g. "Dupont SARL" → "DUPO"). Not guaranteed unique — the backend appends a numeric
// suffix on collision. Used both by the FEC pre-import preview (display) and server-side creation.
export function deriveSupplierCodeFromName(name) {
    const base = (name ?? '')
        .normalize('NFD')
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, '')
        .slice(0, 4);
    return base || 'FOUR';
}
export function signedAccountBalance(movements, normalSide) {
    const positiveSide = normalSide === 'debtor' ? 'debit' : 'credit';
    return sumDecimals(movements.map((movement) => movement.transactionType === positiveSide ? movement.amount : movement.amount.neg()));
}
